import React, { useMemo } from "react";
import GlobalFilter from "../../Utility/GlobalFilter/GlobalFilter";

export default function UserFilter({
  listingFilter,
  handleFilterChange,
  handleFilterReset,
  applyFilters,
  /** Role display names from GET /users/roles (dynamic); falls back to empty list */
  roleNames = [],
  /** Team options from GET /teams — { value: id, label: name } */
  teamOptions = [],
}) {
  const handleStatusChange = (e) => {
    const value = e.target.value === "All" ? "" : e.target.value;
    handleFilterChange({
      target: {
        name: "status",
        value: value,
      },
    });
  };

  const handleRoleChange = (e) => {
    const value = e.target.value === "All" ? "" : e.target.value;
    handleFilterChange({
      target: {
        name: "role",
        value: value,
      },
    });
  };

  const roleDropdownOptions = useMemo(() => {
    const unique = [...new Set(roleNames.map((n) => String(n).trim()).filter(Boolean))];
    return ["All", ...unique.sort((a, b) => a.localeCompare(b))];
  }, [roleNames]);

  const fields = [
    {
      type: "input",
      name: "userName",
      label: "User Name",
      placeholder: "Enter user name",
      // width: "w-48",
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      options: ["All", "Active", "Inactive"],
      placeholder: "All",
      onChange: handleStatusChange,
      // width: "w-48",
      zIndex: true,
    },
    {
      type: "dropdown",
      name: "role",
      label: "Role",
      options: roleDropdownOptions,
      placeholder: "All",
      onChange: handleRoleChange,
      // width: "w-48",
      zIndex: true,
    },
    {
      type: "dropdown",
      name: "teamIds",
      label: "Team",
      options: teamOptions,
      placeholder: "All Teams",
      searchable: true,
      multiselect: true,
      zIndex: true,
    },
  ];

  return (
    <GlobalFilter
      listingFilter={listingFilter}
      handleFilterChange={handleFilterChange}
      handleFilterReset={handleFilterReset}
      applyFilters={applyFilters}
      fields={fields}
      buttonWidth="w-full md:w-auto"
      flexClassName="flex flex-wrap md:flex-nowrap gap-2 items-end"
    />
  );
}
